// Turnstile check on album creation only (D13).

const SITEVERIFY = "https://challenges.cloudflare.com/turnstile/v0/siteverify";

/** Must match `action` in the guest page's turnstile.render() call. */
export const TURNSTILE_ACTION = "create-album";

export async function verifyTurnstile(secret: string, token: string, ip: string): Promise<boolean> {
  if (!token) return false;
  const form = new FormData();
  form.append("secret", secret);
  form.append("response", token);
  if (ip !== "unknown") form.append("remoteip", ip);
  try {
    const res = await fetch(SITEVERIFY, { method: "POST", body: form });
    if (!res.ok) return false;
    const data = (await res.json()) as { success?: boolean; action?: string };
    // A token minted for another action is refused. Cloudflare's test keys return no
    // action, so an empty one is allowed (D22).
    return data.success === true && (!data.action || data.action === TURNSTILE_ACTION);
  } catch {
    return false;
  }
}
